module.exports = __webpack_public_path__ + "img/speaker-add.933d3c48.png";